export default "__VITE_ASSET__SPUIyeKW__"